import { EnvironmentOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import { TaskType } from 'core/modules/tasks/task.interface';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var TaskZoneTag = function TaskZoneTag(_ref) {
  var _task$content, _task$content2, _task$content$zone$de, _task$content$zone;

  var task = _ref.task;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if ((task === null || task === void 0 ? void 0 : (_task$content = task.content) === null || _task$content === void 0 ? void 0 : _task$content.type) !== TaskType.Report) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  if (!(task !== null && task !== void 0 && (_task$content2 = task.content) !== null && _task$content2 !== void 0 && _task$content2.zone)) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: "".concat(t('form.task.zone.label'), ": ").concat(task.content.zone.name, " - ").concat((_task$content$zone$de = task.content.zone.description) !== null && _task$content$zone$de !== void 0 ? _task$content$zone$de : ''),
      children: /*#__PURE__*/_jsx(Tag, {
        className: "zone",
        icon: /*#__PURE__*/_jsx(EnvironmentOutlined, {}),
        children: (_task$content$zone = task.content.zone) === null || _task$content$zone === void 0 ? void 0 : _task$content$zone.name
      })
    }, "zone")
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "ZoneTag__Container",
  componentId: "sc-1rimekb-0"
})([".ant-tag{display:block;overflow:hidden;max-width:100px;padding-right:10px;text-overflow:ellipsis;}"]);